<template>
  <b-container class="base-container">
    <b-row align-v="center">
      <b-col class="member-col" :key="key" v-for="(member, key) in members">
        <TeamMember :member="member"></TeamMember>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TeamMember from './Components/TeamMember.vue';
export default {
  data: function() {
    return {
      members: [
        {
          name: 'Lucas Golden',
          title: 'Chief Executive Officer',
          file: 'lucasg.jpeg'
        },
        {
          name: 'Matthew Bollinger',
          title: 'Chief Operating Officer',
          file: 'mattbCROP.jpg'
        },
        {
          name: 'Matthew Smith',
          title: 'Chief Technology Officer',
          file: 'mattsCROP.jpg'
        },
        {
          name: 'Jack Doren',
          title: 'Chief Experience Officer',
          file: 'JDProfile.jpeg'
        },
        {
          name: 'Kyle Mirley',
          title: 'VP of Engineering',
          file: 'user.png'
        },
        {
          name: 'Justin Eric Mills',
          title: 'Chief Marketing Officer',
          file: 'user.png'
        }
      ]
    };
  },
  components: { TeamMember }
};
</script>

<style scoped>
.base-container {
  height: calc(100% - 157px);
  margin-top: 2rem;
}
.member-col {
  min-width: 230px;
  margin-bottom: 60px;
}
</style>
